import type { TOC } from '@ember/component/template-only';
import { formatNumber } from 'ember-intl';
import { gte, lte } from 'ember-truth-helpers';

interface GeneralPercentageChangeValueSignature {
  Args: {
    changeValue?: number | null;
  };
}

const GeneralPercentageChangeValue = <template>
  <span
    class="text-200--regular
      {{if (gte @changeValue 0.005) 'text-success-default'}}
      {{if (lte @changeValue -0.005) 'text-critical-default'}}"
  >
    {{formatNumber
      @changeValue
      maximumFractionDigits=0
      signDisplay="exceptZero"
      style="percent"
    }}
  </span>
</template> satisfies TOC<GeneralPercentageChangeValueSignature>;

export default GeneralPercentageChangeValue;
